"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_FORMAT_TABLE = exports.BUILDIN_NUMBER_FORMAT = void 0;
/**
 * 内置数值格式
 */
exports.BUILDIN_NUMBER_FORMAT = [
    'General',
    '0',
    '0.00',
    '#,##0',
    '#,##0.00',
    '\\¥#,##0;\\¥-#,##0',
    '\\¥#,##0;]\\¥-#,##0',
    '\\¥#,##0.00;\\¥-#,##0.00',
    '\\¥#,##0.00;]\\¥-#,##0.00',
    '0%',
    '0.00%',
    '0.00E+00',
    '# ?/?',
    '# ??/??',
    'yyyy/m/d',
    'd-mmm-yy',
    'd-mmm',
    'mmm-yy',
    'h:mm AM/PM',
    'h:mm:ss AM/PM',
    'h:mm',
    'hh:mm:ss',
    'yyyy/m/d h:mm',
    '\\$#,##0_);(\\$#,##0)',
    '\\$#,##0_);](\\$#,##0)',
    '\\$#,##0.00_);(\\$#,##0.00)',
    '\\$#,##0.00_);](\\$#,##0.00)',
    'yyyy"年"m"月"',
    'm"月"d"日"',
    'm"月"d"日"',
    'm/d/yy',
    'yyyy"年"m"月"d"日"',
    'h"时"mm"分"',
    'h"时"mm"分"ss"秒"',
    '上午/下午h"时"mm"分"',
    '上午/下午h"时"mm"分"ss"秒"',
    'yyyy"年"m"月"',
    '#,##0;-#,##0',
    '#,##0;]-#,##0',
    '#,##0.00;-#,##0.00',
    '#,##0.00;]-#,##0.00',
    '_ * #,##0_ ;_ * -#,##0_ ;_ * "-"_ ;_ @_ ',
    '_ \\¥* #,##0_ ;_ \\¥* -#,##0_ ;_ \\¥* "-"_ ;_ @_ ',
    '_ * #,##0.00_ ;_ * -#,##0.00_ ;_ * "-"??_ ;_ @_ ',
    '_ \\¥* #,##0.00_ ;_ \\¥* -#,##0.00_ ;_ \\¥* "-"??_ ;_ @_ ',
    'mm:ss',
    'mm:ss',
    'mm:ss.0',
    '##0.0E+0',
    '@',
    'yyyy"年"m"月"',
    'm"月"d"日"',
    'yyyy"年"m"月"',
    'm"月"d"日"',
    'm"月"d"日"',
    '上午/下午h"时"mm"分"',
    '上午/下午h"时"mm"分"ss"秒"',
    'yyyy"年"m"月"',
    'm"月"d"日"',
    '0',
    '0.00',
    '#,##0',
    '#,##0.00',
    '\\¥#,##0;\\¥-#,##0',
    '\\¥#,##0;]\\¥-#,##0',
    '\\¥#,##0.00;\\¥-#,##0.00',
    '\\¥#,##0.00;]\\¥-#,##0.00',
    '0%',
    '0.00%',
    '# ?/?',
    '# ??/??',
    'yyyy/m/d',
    'yyyy/m/d',
    'd-mmm-yy',
    'd-mmm',
    'mmm-yy',
    'h:mm',
    'h:mm:ss',
    'yyyy/m/d h:mm',
    'mm:ss',
    'mm:ss',
    'mm:ss.0',
];
/**
 * 自定义格式框内数值格式
 */
exports.CUSTOM_FORMAT_TABLE = [
    {
        label: 'G/通用格式',
        formatData: 'General',
    },
    {
        label: '0',
        formatData: '0',
    },
    {
        label: '0.00',
        formatData: '0.00',
    },
    {
        label: '#,##0',
        formatData: '#,##0',
    },
    {
        label: '#,##0.00',
        formatData: '#,##0.00',
    },
    {
        label: '#,##0;-#,##0',
        formatData: '#,##0;-#,##0',
    },
    {
        label: '#,##0;[Red]-#,##0',
        formatData: '#,##0;[Red]-#,##0',
    },
    {
        label: '#,##0.00;-#,##0.00',
        formatData: '#,##0.00;-#,##0.00',
    },
    {
        label: '#,##0.00;[Red]-#,##0.00',
        formatData: '#,##0.00;[Red]-#,##0.00',
    },
    {
        label: '¥#,##0;¥-#,##0',
        formatData: '"¥"#,##0;"¥"-#,##0',
    },
    {
        label: '¥#,##0;[Red]¥-#,##0',
        formatData: '"¥"#,##0;[Red]"¥"-#,##0',
    },
    {
        label: '¥#,##0.00;¥-#,##0.00',
        formatData: '"¥"#,##0.00;"¥"-#,##0.00',
    },
    {
        label: '¥#,##0.00;[Red]¥-#,##0.00',
        formatData: '"¥"#,##0.00;[Red]"¥"-#,##0.00',
    },
    {
        label: '0%',
        formatData: '0%',
    },
    {
        label: '0.00%',
        formatData: '0.00%',
    },
    {
        label: '0.00E+00',
        formatData: '0.00E+00',
    },
    {
        label: '##0.0E+0',
        formatData: '##0.0E+0',
    },
    {
        label: '# ?/?',
        formatData: '# ?/?',
    },
    {
        label: '# ??/??',
        formatData: '# ??/??',
    },
    {
        label: '$#,##0_);($#,##0)',
        formatData: '$#,##0_);($#,##0)',
    },
    {
        label: '$#,##0_);[Red]($#,##0)',
        formatData: '$#,##0_);[Red]($#,##0)',
    },
    {
        label: '$#,##0.00_);($#,##0.00)',
        formatData: '$#,##0.00_);($#,##0.00)',
    },
    {
        label: '$#,##0.00_);[Red]($#,##0.00)',
        formatData: '$#,##0.00_);[Red]($#,##0.00)',
    },
    {
        label: 'yyyy"年"m"月"',
        formatData: 'yyyy"年"m"月"',
    },
    {
        label: 'm"月"d"日"',
        formatData: 'm"月"d"日"',
    },
    {
        label: 'yyyy/m/d',
        formatData: 'yyyy/m/d',
    },
    {
        label: 'yyyy"年"m"月"d"日"',
        formatData: 'yyyy"年"m"月"d"日"',
    },
    {
        label: 'm/d/yy',
        formatData: 'm/d/yy',
    },
    {
        label: 'd-mmm-yy',
        formatData: 'd-mmm-yy',
    },
    {
        label: 'd-mmm',
        formatData: 'd-mmm',
    },
    {
        label: 'mmm-yy',
        formatData: 'mmm-yy',
    },
    {
        label: 'h:mm AM/PM',
        formatData: 'h:mm AM/PM',
    },
    {
        label: 'h:mm:ss AM/PM',
        formatData: 'h:mm:ss AM/PM',
    },
    {
        label: 'h:mm',
        formatData: 'h:mm',
    },
    {
        label: 'h:mm:ss',
        formatData: 'h:mm:ss',
    },
    {
        label: 'h"时"mm"分"',
        formatData: 'h"时"mm"分"',
    },
    {
        label: 'h"时"mm"分"ss"秒"',
        formatData: 'h"时"mm"分"ss"秒"',
    },
    {
        label: '上午/下午h"时"mm"分"',
        formatData: '上午/下午h"时"mm"分"',
    },
    {
        label: '上午/下午h"时"mm"分"ss"秒"',
        formatData: '上午/下午h"时"mm"分"ss"秒"',
    },
    {
        label: 'yyyy/m/d h:mm',
        formatData: 'yyyy/m/d h:mm',
    },
    {
        label: 'mm:ss',
        formatData: 'mm:ss',
    },
    {
        label: 'mm:ss.0',
        formatData: 'mm:ss.0',
    },
    {
        label: '@',
        formatData: '@',
    },
    {
        label: '[h]:mm:ss',
        formatData: '[h]:mm:ss',
    },
];
//# sourceMappingURL=format-code-const.js.map